import { render } from "./CompanySetting.vue?vue&type=template&id=95662e20&scoped=true"
import script from "./CompanySetting.vue?vue&type=script&lang=js"
export * from "./CompanySetting.vue?vue&type=script&lang=js"

import "./CompanySetting.vue?vue&type=style&index=0&id=95662e20&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95662e20"]])

export default __exports__